var map = {
	"./demos/basic/index.ts": 49485,
	"./demos/children/index.ts": 70665,
	"./demos/layout/index.ts": 79721,
	"./demos/line/index.ts": 94548,
	"./demos/select/index.ts": 57088,
	"./demos/shape/index.ts": 42624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78195;